import React, { useEffect } from "react";
import { Button, Modal } from "semantic-ui-react";
import Wave2 from "../../../images/modalWave2.svg";
import './ConfirmModal.scss';

export type ConfirmModalProps = {

    confirmFunc: Function; // delete function you will pass the itemToDelete to ?
    confirmText: string | React.ReactNode; // Message that is passed into Modal to display to user
    openModal: boolean; // controls open/close of modal from parent
    setOpenModal: Function; // controls open/close of modal from parent
    icon?: string; // icon to display example for trash can ```trash alternate outline```
    displayName?: string; // name to display in the modal
    tempStatus?: number; //temporarily holds status id of button that was clicked (Draft or Final) until they click ok to change it in watershedReportForm 
}

export const ConfirmModal: any = (props: ConfirmModalProps) => {

    const [open, setOpen] = React.useState(false);

    //this will run the function passed into it (currently either onStatusChange (modal1) or confirmCreateReport (modal2) )
    const confirmAndClose = () => {
        if (props.tempStatus) {
            props.confirmFunc(props.tempStatus);
            props.setOpenModal(false);

        } else {
            props.confirmFunc();
            props.setOpenModal(false);
        }
    }

    useEffect(() => {
        setOpen(props.openModal)
    }, [props.openModal]);

    return (
        <Modal
            className="confirm-modal"
            size="tiny" // options are mini tiny small large or fullscreen
            centered={true}
            open={open}
            onClose={() => props.setOpenModal(false)}
            onOpen={() => setOpen(true)}>

            <Modal.Content>{props.confirmText}</Modal.Content>

            <Modal.Actions>
                <div className="wave-div">
                    <img src={Wave2} alt="wave" className="wave" />
                </div>
                <div className="modal-btns">
                    <Button className="confirm-btn" onClick={confirmAndClose}>OK</Button>
                    <Button className="cancel-btn" onClick={() => { props.setOpenModal(false) }}>Cancel</Button>
                </div>
            </Modal.Actions>
        </Modal>
    )
}